import {
    InitiateAuthCommand,
    CognitoIdentityProviderClient,
} from "@aws-sdk/client-cognito-identity-provider";
import { loginAsync } from "../../store/slices/authSlice";
import { fetchUserProfile } from "../../store/slices/authSlice";
import { saveTokens } from "../../utils/tokenUtils";
import { fetchFullProfile, fetchProfilePhoto } from "../../store/slices/profileSlice";
import { jwtDecode } from "jwt-decode";

const cognitoClient = new CognitoIdentityProviderClient({ region: "ca-central-1" });

interface JwtPayload {
    sub: string;
    email: string;
    token_use: string;
    exp: number;
}

const authenticateUser = async (email: string, password: string, dispatch: any, navigate: any) => {
    try {
        const command = new InitiateAuthCommand({
            AuthFlow: "USER_PASSWORD_AUTH",
            ClientId: "5u806hjmmcee0qu442qddug8gv",
            AuthParameters: {
                USERNAME: email,
                PASSWORD: password,
            },
        });

        const response = await cognitoClient.send(command);

        if (response.$metadata.httpStatusCode !== 200) {
            console.error("❌ Cognito returned non-200 status:", response.$metadata.httpStatusCode);
            throw new Error("Authentication failed");
        }

        const accessToken = response.AuthenticationResult?.AccessToken;
        const refreshToken = response.AuthenticationResult?.RefreshToken;

        if (accessToken && refreshToken) {
            // Store tokens with expiration (in both localStorage and cookies)
            saveTokens(accessToken, refreshToken);

            // Dispatch Redux actions
            await dispatch(loginAsync(accessToken));
            await dispatch(fetchUserProfile(accessToken));
            dispatch(fetchFullProfile(accessToken));

            // Also fetch the profile photo separately
            try {
                // Get the user ID from the token to fetch profile photo
                const decodedToken = jwtDecode<JwtPayload>(accessToken);
                const userId = decodedToken.sub;

                if (userId) {
                    console.log(
                        "[AuthenticateUser] Fetching profile photo after login for user:",
                        userId,
                    );
                    dispatch(fetchProfilePhoto(userId));
                }
            } catch (photoError) {
                console.error("Error fetching profile photo, but continuing login:", photoError);
            }

            // // if no profile, then redirect to profile setup
            // if (result.error) {
            //   navigate("/profile-setup");
            // } else {
            //   navigate("/newsfeed");
            // }
        } else {
            console.error("❌ Authentication failed: No tokens returned from Cognito");
            throw new Error("Authentication failed. No tokens returned.");
        }
    } catch (error: any) {
        // Log the error properly for debugging
        console.error("❌ Login failed:", error);

        // Check for specific Cognito error types
        if (error.name === "UserNotConfirmedException") {
            // Preserve the original error name for handling in the Login component
            const notConfirmedError = new Error(
                "User email is not confirmed! 📧 Please check your email for a verification code.",
            );
            notConfirmedError.name = "UserNotConfirmedException";

            throw notConfirmedError;
        }

        // For all other errors, rethrow the original error
        throw error;
    }
};

export default authenticateUser;
